/* eslint-disable no-console */
import { useEffect, useState } from 'react';
import { s3 } from 'Services/AWS/s3';

/** @type {import('Services/AWS/s3').FileObject} */
const defaultValue = {
  key: '',
  prefix: '',
  count: 0,
  files: [],
};

/**
 * Hook para obtener las evaluaciones de un curso.
 *
 * @param {string|null|undefined} key - Llave para obtener la evaluación de un curso en S3.
 */
const useEvaluations = key => {
  const [evaluations, setEvaluations] = useState(defaultValue);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  /**
   * Método para obtener las evaluaciones y actualizar los estados.
   *
   * @param {string} keyProvided - Llave para obtener la evaluación de un curso en S3.
   */
  const fetchEvaluations = async keyProvided => {
    try {
      setError(null);
      setLoading(true);
      const response = await s3.getListObjects(keyProvided || key);
      setEvaluations(response);
      return response;
    } catch (caught) {
      console.error('Error fetching evaluations: ', caught);
      setError(caught);
      return evaluations;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (key) {
      fetchEvaluations();
    }
  }, [key]);

  return {
    fetchEvaluations,
    evaluations,
    loading,
    error,
  };
};

export default useEvaluations;
